import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { HelperService } from '@app/core/services/helper.service';

import { environment } from '@environments/environment';

@Component({
	selector: 'cng-vehicle-title',
	templateUrl: './vehicle-title.component.html',
	styleUrls: ['./vehicle-title.component.less'],
})
export class ConfigureVehicleTitleComponent implements OnInit {
	@Input() vehicle: any = null;
	@Input() always_stacked: boolean = false;
	@Input() show_icon_list: boolean = false;
	@Input() show_cta: boolean = false;
	@Input() cta_loading: boolean = false;
	@Input() cta_text: string = null;
	@Input() show_registration: boolean = false;
	@Input() show_price: boolean = false;
	@Input() view?: string;

	@Output() cta = new EventEmitter();

	imageErrorCount: number = 0;

	constructor(private helper_service: HelperService) {}

	ngOnInit(): void {
		this.vehicle.brand_logo_url = this.helper_service.buildManufacturerBrandLogoUrl(this.vehicle.make);
	}

	onCtaClick(): void {
		this.cta.emit(this.vehicle);
	}

	get isValuationModalView(): boolean {
		if (this.view === 'valuation_modal') {
			return true;
		}

		return false;
	}

	onImageError(image: HTMLImageElement): void {
		image.src = `${environment.deploy_protocol}${environment.deploy_domain}/assets/icons/icon_car.svg`;
		image.style.opacity = '0.3';
		this.imageErrorCount += 1;
	}
}
